import { createSlice } from "@reduxjs/toolkit";
const initialState = {
 // keep the key only if Colum is present in the table
 // keep true to show the column else false to hide 
  data: {
    // calendarTitle: true,
    startDate: true,
    endDate: true,
    // viewWorkDays:true,
    // viewWorkHours:true,
    viewHolidays:true,
    associatedProjects: true,
  },
};

export const CalendarsListViewTableColumnsConfigSlice = createSlice({
  name: "CalendarsListViewTableColumnsConfig",
  initialState,
  reducers: {
    updateCalendarsListViewTableColumnsConfig(state, action) {
      state.data = { ...state.data, ...action.payload };
    },
    resetCalendarsListViewTableColumnsConfig(state) {
      state.data = initialState.data;
    },
  },
});

export const {
  updateCalendarsListViewTableColumnsConfig,
  resetCalendarsListViewTableColumnsConfig,
} = CalendarsListViewTableColumnsConfigSlice.actions;

